// extracted by mini-css-extract-plugin
export default {"detailsGrid":"ClaimableBalanceModal_detailsGrid__jgptx","label":"ClaimableBalanceModal_label__JDsG0","content":"ClaimableBalanceModal_content__tOhwN"};